import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";
import allSuperAdminRoutes from "./modules";
import axios from "@/helpers/axios";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    ...allSuperAdminRoutes,
    {
      path: "/error-404",
      name: "error-404",
      component: () => import("@/views/error/Error404.vue"),
      meta: {
        layout: "full",
      },
    },
    {
      path: "/error-403",
      name: "error-403",
      component: () => import("@/views/error/Error403.vue"),
      meta: {
        layout: "full",
      },
    },
    {
      path: "*",
      redirect: "error-404",
    },
  ],
});

router.beforeEach(async (to, from, next) => {
  const isSuperAdmin = store.getters["superAdminAuthModule/getIsAuthenticated"];

  // Redirect to login if route requires SuperAdmin and user is not authenticated
  if (to.meta.requiresSuperAdmin && !isSuperAdmin) {
    return next({ path: "/super-admin-login", query: { redirect: to.fullPath } });
  }
  
  if (to.matched.some(record => record.meta.requiresSuperAdmin) && isSuperAdmin) {
    try {
      // Fetch user with roles & permissions
      const resUser = await axios.post("/api/super-admin/user");

      const { user, permissions } = resUser?.data?.data;

      // Store user in Vuex
      await store.dispatch("superAdminAuthModule/setUser", {
        user,
      });

      await store.dispatch("superAdminAuthModule/setPermissions", {
          permissions: permissions?.map((item) => item.name) || [],
      });
      // If route has specific permission gate
      if (to.meta.gate) {
        const userPermissions = store.getters["superAdminAuthModule/getPermissions"];
        if (userPermissions.includes(to.meta.gate)) {
          return next();
        }
      }
    } catch (error) {
      console.error("Error during super admin auth guard:", error);
      // Clear auth state on error
      await store.dispatch("superAdminAuthModule/setIsAuthenticated", {
        isAuthenticated: false,
        token: null,
        refreshToken: null,
      });
      await store.dispatch("superAdminAuthModule/clearPersistedState");
      await store.dispatch("superAdminAuthModule/removeUser");
      await store.dispatch("superAdminAuthModule/setPermissions", {
        permissions: [],
      });

      window.location.href = "/super-admin-login";
    }
  } else {
    return next();
  }
});

  

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById("loading-bg");
  if (appLoading) {
    appLoading.style.display = "none";
  }
});

export default router;
